import intl from "../services/intl";

const Currency = ({ value, round = false, postfix = false, ...props }) =>
  intl.formatCurrency(value, { round, postfix, ...props });

export default Currency;
